import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const MGMResorts = ({featuredProjectsList}) => {
  const project = getProject('mgm-resorts');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '275229195'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="building-a-stage-for-universal-love">
            Building a stage for universal love
          </h2>
          <p>
            To spread the movement of universal love from the wedding capital of
            the world — Las Vegas —, MGM Resorts teamed up with McCann New York
            to release Universal Love, a collection of wedding songs that have
            been reimagined for the LGBTQ community.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20180615135203/22.png'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The album features iconic artists, such as Bob Dylan and Kesha,
            performing classic love songs with their pronouns changed to reflect
            the universality of love. With the project’s grand purpose, the
            updated but timeless songs, and the cover artwork from Craig and
            Karl, McCann came to us to build a space to host and amplify this
            revolution.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20180615100230/4.png'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20180615100217/1.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="creativity-with-intent">Creativity with intent</h2>
          <p>
            With the vibrant cover artwork from Craig and Karl as inspiration,
            the possibilities for creative expression were endless. To ensure
            the platform achieves its monumental mission, we established an
            execution strategy that aims to balance both communication and
            emotional objectives.
          </p>
          <ul>
            <li>To be celebratory: this is a momentous time for love</li>
            <li>To be loud: because support for a revolution must be bold</li>
            <li>
              To be exciting: since love, in all its forms, is fun and
              sensational
            </li>
          </ul>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20180615120529/52.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="translating-the-manifesto-into-interaction">
            Translating the manifesto into interaction
          </h2>
          <p>
            A natural channel to transmit the music was through the album’s
            artwork, particularly the rainbow at its center, which reflects the
            color sequence of the LGBTQ pride flag. Our aim was to infuse
            feelings of festivity, joy, and love into every aspect of the
            website.
          </p>
        </AnimateIn>

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '275231707'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            With small details like creating the chance to listen to love
            itself, hearts bursting with elation, and an explosion of color when
            browsing through the rainbow, the site embraces each user in the
            movement of love for all.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20180615100226/3.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            <a href="https://www.mccannny.com" target="_blank" rel="noopener">
              McCann New York
            </a>
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Creative Strategy',
                  'Experience Mapping',
                  'Prototyping & Validation',
                  'Technical Strategy',
                  'UX Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Motion Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'DevOps',
                  'Front-end Development',
                  'Functional Prototyping'
                ]
              },

              {
                title: 'Delivery',
                items: ['Launch', 'Monitoring', 'Quality Assurance']
              },

              {
                title: 'Content',
                items: ['Animation']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://www.universal-love.com/',
            title: 'Visit website'
          }}
        />
        
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default MGMResorts;
